











































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Client, Token} from '@/models';

import storeClient from '@/stores/modules/client';

import InputPhone from '@/components/Input/Phone.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";
import {Stored} from "vue-stored-prop-decorator";
import storeToken from "@/stores/modules/token";

@Component({
	components: {
		InputPhone,
		InputCountry,
		InputZipCode,
	}
})
export default class CrudClientEditPdf extends AbstractEditVue<Client> {

	// DF: utiliser pour la création d'un client uniquement
	// en modification on passe par la light
	private step: number = 1;

	private d = new Date()
	private dateDayBefore = this.doDate()
	private dates = [this.dateToYMD(this.dateDayBefore), this.dateToYMD(this.d)];
	private menu = false;
	private startDate = null;
	private endDate = null;
	private detail = false;

	public constructor() {
		super(
			storeClient,
			'Client modifié',
			'Client créé',
		);
	}

	@Stored(() => storeToken)
	private token: Token;

	private dateToYMD(date) {
		let d = date.getDate();
		let m = date.getMonth() + 1; //Month from 0 to 11
		let y = date.getFullYear();
		return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
	}

	private doDate() {
		let d = new Date()
		d.setDate(d.getDate() - 30)
		return d
	}

	private get hrefPdf() {
		return `${process.env.VUE_APP_BACK_BASE_URL}/pdf/client/${this.item}/${this.startDate}/${this.endDate}/${this.detail}?token=${this.token.id}`;
	}

	public async mounted(): Promise<void> {
		await super.mounted();
		this.startDate = this.dates[0]
		this.endDate = this.dates[1]
	}

	private doRequest() {
		let date = new Date(this.dates[0])
		let date2 = new Date(this.dates[1])

		if (date.getDate() > date2.getDate()) {
			this.startDate = this.dates[1]
			this.endDate = this.dates[0]
		} else {
			this.startDate = this.dates[0]
			this.endDate = this.dates[1]
		}
	}

}
